import React, { useState, useLayoutEffect } from 'react';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import classes from './newPhysician.module.scss';
import { RangeDatePicker } from '../../../_common/Form/DatePickers/RangeDatePicker/RangeDatePicker';
import { useQuery } from '../../../../utils/hooks/useQuery';
import Button from '../../../_common/Form/Buttons/Button';
import { specOptions } from '../../../../utils/data/data';
import Select from '../../../_common/Form/Selects/Select/Select';
import utils from '../../../../utils/utils';
import Loader from '../../../_common/Loader/Loader';
import TableAndPagination from '../../../_common/TableAndPagination/TableAndPagination';
import {
  clearProduct,
  getDashboardNewPhysician,
  searchProduct,
} from '../../../../store/actions/dashboard';
import SelectWithSearch from '../../../_common/Form/Selects/SelectWithSearch/SelectWithSearch';

const tableHeader = [
  {
    name: 'Name',
    path: 'name',
  },
  {
    name: 'Group',
    path: 'group',
  },
  {
    name: 'Rep',
    path: 'rep',
  },
  {
    name: 'Prescription Count',
    path: 'sales',
  },
  {
    name: 'Total Spent',
    path: 'revenue',
  },
];

const collectRequestData = (requestData) => {
  const data = utils.deleteEmptyKeys(requestData);

  if (data.start) {
    if (!data.end) {
      data.end = moment(data.start).add(1, 'day').format('YYYY-MM-DD');
    } else {
      data.end = moment(data.end).add(1, 'day').format('YYYY-MM-DD');
    }
  }

  return data;
};

const thisMonthStartDay = moment().startOf('month').format('YYYY-MM-DD');
const thisMonthEndDate = moment().format('YYYY-MM-DD');
let timeout;

function NewPhysician() {
  const dispatch = useDispatch();
  const { query, setQuery } = useQuery();
  const [requestData, setRequestData] = useState({
    start: query.start || thisMonthStartDay,
    end: query.start && !query.end ? '' : query.end || thisMonthEndDate,
    specialization: query.specialization || '',
    productId: query.productId || '',
    page: query.page || 1,
    limit: query.limit || 15,
  });
  const { dashboardPageData, dashboardTotalPage, dashboardProduct } = useSelector((store) => store.dashboard);
  const [searchProductValue, setSearchProductValue] = useState(query.productName || '');
  const [searchProductLoading, setSearchProductLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const { page, limit, specialization } = requestData;

  useLayoutEffect(() => {
    (async () => {
      setLoading(true);
      await dispatch(getDashboardNewPhysician(collectRequestData(requestData)));
      setLoading(false);
    })();
  }, []);

  const onChangeDate = (currentDate) => {
    setRequestData((prev) => ({ ...prev, start: currentDate[0], end: currentDate[1] }));
  };

  const clearFilters = async () => {
    const defaultRequestData = {
      start: thisMonthStartDay,
      end: thisMonthEndDate,
      page: 1,
      limit: 15,
    };

    setSearchProductValue('');

    setRequestData(defaultRequestData);

    setQuery(defaultRequestData);

    setLoading(true);
    await dispatch(getDashboardNewPhysician(defaultRequestData));
    setLoading(false);
  };

  const onUpdateClick = async () => {
    const data = collectRequestData(requestData);
    data.page = 1;

    setLoading(true);
    await dispatch(getDashboardNewPhysician(data));

    setRequestData((prev) => ({ ...prev, page: 1 }));

    if (data.productId) data.productName = searchProductValue;

    setQuery(data);
    setLoading(false);
  };

  const changeProduct = (value) => {
    setSearchProductValue(value);

    clearTimeout(timeout);
    dispatch(clearProduct());

    if (value.trim()) {
      setSearchProductLoading(true);

      timeout = setTimeout(async () => {
        await dispatch(searchProduct(value));
        setSearchProductLoading(false);
      }, 400);
    } else {
      setSearchProductLoading(false);
    }
  };

  const changeRequestData = (path, value, searchValue) => {
    if (searchValue) setSearchProductValue(searchValue);

    setRequestData((prev) => ({ ...prev, [path]: value }));
  };

  const onChangePageData = async (path, count) => {
    const newRequestData = { ...requestData, [path]: count };

    if (path === 'limit') {
      newRequestData.page = 1;
    }

    const data = collectRequestData(newRequestData);
    await dispatch(getDashboardNewPhysician(data));

    setRequestData(newRequestData);

    if (data.productId) data.productName = searchProductValue;

    setQuery(data);
  };

  return (
    <div className={classes.wrapper}>
      <div className={classes.wrapper_header}>
        <div style={{ marginRight: 10 }}>
          <RangeDatePicker
            currentDate={requestData}
            onChangeDate={onChangeDate}
          />
        </div>

        <div className={classes.product}>
          <SelectWithSearch
            label="Product"
            optionPathname="name"
            optionKey="id"
            options={dashboardProduct}
            searchValue={searchProductValue}
            onChange={changeProduct}
            loading={searchProductLoading}
            onSelectOption={(option, searchValue) => changeRequestData('productId', option, searchValue)}
          />
        </div>

        <div className={classes.specialization}>
          <Select
            label="All specializations"
            options={specOptions}
            currentOption={specialization}
            onChange={(option) => changeRequestData('specialization', option)}
          />
        </div>

        <div className={classes.buttonContainer}>
          <Button title="Update" onClick={onUpdateClick} className={classes.updateButton} />

          <Button title="Clear" className={classes.updateButton} clearButton onClick={clearFilters} />
        </div>

      </div>

      <div className={classes.table_wrapper}>
        {loading
          ? <Loader />

          : (
            <TableAndPagination
              onChange={onChangePageData}
              data={dashboardPageData}
              header={tableHeader}
              totalPage={+dashboardTotalPage}
              page={+page - 1}
              limit={+limit}
            />
          )}
      </div>
    </div>
  );
}
export default NewPhysician;
